import { EmbedCodeTokens } from "../types";
import { serverUrl, baseUrl } from "@kaltura/mediaspace-shared-utils";

/**
 * single media (not playlist) secure embed code
 */
export default class SecureEmbed {
    // noinspection HtmlUnknownTarget,HtmlUnknownAttribute,HtmlDeprecatedAttribute
    static template =
        '<iframe id="kmsembed-{ENTRY_ID}" width="{WIDTH}" height="{HEIGHT}" src="{IFRAME_URL}" class="kmsembed" allowfullscreen webkitallowfullscreen mozAllowFullScreen allow="autoplay *; fullscreen *; encrypted-media *" referrerPolicy="no-referrer-when-downgrade" {SANDBOX} frameborder="0" title="{TITLE}"></iframe>';

    /**
     * generate dynamic embed
     */
    static secureEmbed(params: EmbedCodeTokens) {
        const playbackContext = params["PLAYBACK_CONTEXT"] ?? null;
        const startTime = params["START_TIME"] ?? null;
        const endTime = params["END_TIME"] ?? null;
        const omitSandbox = params["OMIT_SANDBOX"] ?? false;

        let out = SecureEmbed.template;
        const serverUrlStr = serverUrl.length > 0 ? `${serverUrl}/` : "";
        const baseUrlStr = baseUrl.length > 0 ? `${baseUrl}/` : "";
        let iframeUrl = `${serverUrlStr}${baseUrlStr}embed/secure/iframe/entryId/{ENTRY_ID}/uiConfId/{UICONF_ID}`;
        if (playbackContext) {
            // "pbc" aka "playback context" is a channel/category id, to play media from
            iframeUrl += `/pbc/${playbackContext}`;
        }
        if (startTime) {
            iframeUrl += `/st/${startTime}`;
        }
        if (endTime) {
            iframeUrl += `/ed/${endTime}`;
        }

        out = out.replace("{IFRAME_URL}", iframeUrl);

        const iframeSandboxAttr = omitSandbox
            ? ""
            : 'sandbox="allow-forms allow-same-origin allow-scripts allow-top-navigation allow-pointer-lock allow-popups allow-modals allow-orientation-lock allow-popups-to-escape-sandbox allow-presentation allow-top-navigation-by-user-activation"';
        out = out.replace("{SANDBOX}", iframeSandboxAttr);

        for (const [name, value] of Object.entries(params)) {
            const rg = new RegExp("{" + name + "}", "g");
            out = out.replace(rg, value);
        }

        return out;
    }
}
